// import React from "react";
// import { connect } from "react-redux";
// import { withTranslation } from "react-i18next";
// import AppContext from "../../components/AppContext";
// import PageHeader from "../../components/PageHeader";
// import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
// import { Card, Empty, Table, Tabs, Button, Modal, Form, Select, Input, DatePicker, Divider, Space, Dropdown } from "antd";
// import RangePickerApp from "../../components/rangePickerApp";
// import dayjs from "dayjs";
// import { getBillingDateRange } from "../../helpers/getBillingDateRange";
// import Apiauth from "../../api/Apiauth";
// import { calculateNetIncome, scrollToAntSpinContainer, showToast } from "../../utils";
// import { FileDoneOutlined, CheckOutlined, EllipsisOutlined } from "@ant-design/icons";
// import i18next from "i18next";
// import { CopyTextToClipboard } from "../../helpers/copy";
// import moment from "moment";

// const dataDate = getBillingDateRange();

// class ManageInvoices extends React.Component {
//     static contextType = AppContext;
//     formRef = React.createRef();
//     constructor(props) {
//         super(props);
//         this.state = {
//             loading: false,
//             startDate: dayjs(dataDate?.objectDate?.startDate).subtract(1, "month").startOf("month"),
//             isMobile: window.innerWidth <= 768,
//             dataSource: [],
//             buttonLoading: 0,
//             tableParams: {
//                 pagination: {
//                     current: 1,
//                     pageSize: 10,
//                     total: 0,
//                 },
//                 filters: {},
//                 sortField: null,
//                 sortOrder: null,
//             },
//         };
//     }

//     componentDidMount() {
//         window.addEventListener("resize", this.handleResize);
//         this.fetchData();
//     }

//     componentWillUnmount() {
//         window.removeEventListener("resize", this.handleResize);
//     }

//     handleResize = () => {
//         this.setState({ isMobile: window.innerWidth <= 768 });
//     };

//     fetchData = async (date) => {
//         const { startDate, tableParams } = this.state;
//         const targetDate = date || startDate;

//         this.setState({ loading: true });

//         const payload = {
//             startDate: dayjs(targetDate).format("YYYY-MM-DD"),
//             limit: tableParams.pagination.pageSize,
//             page: tableParams.pagination.current,
//             sortField: tableParams.sortField,
//             sortOrder: tableParams.sortOrder,
//         };

//         try {
//             const res = await Apiauth.getInvoiceList(payload);
//             if (res.status === 200) {
//                 // อิงจาก JSON ที่ให้มา: ข้อมูลอยู่ใน res.data.data และจำนวนทั้งหมดอยู่ใน res.data.total
//                 const prodArray = Array.isArray(res.data?.data) ? res.data.data : [];
//                 console.log()
//                 this.setState({
//                     dataSource: prodArray,
//                     tableParams: {
//                         ...tableParams,
//                         pagination: {
//                             ...tableParams.pagination,
//                             total: res.data.count,
//                         }
//                     }
//                 });
//             }
//         } catch (error) {
//             console.error("Error fetching data:", error);
//             showToast("error", "Failed to fetch data.");
//         } finally {
//             setTimeout(() => {
//                 this.setState({ loading: false });
//             }, 500);
//         }
//     };

//     onChangeDate = (item) => {
//         const newStartDate = dayjs(item?.startDate);
//         this.setState(prevState => ({
//             startDate: newStartDate,
//             tableParams: {
//                 ...prevState.tableParams,
//                 pagination: { ...prevState.tableParams.pagination, current: 1 }
//             }
//         }), () => {
//             this.fetchData(newStartDate);
//         });
//     };

//     handleTableChange = (pagination, filters, sorter) => {
//         this.setState(
//             (prevState) => ({
//                 tableParams: {
//                     ...prevState.tableParams,
//                     pagination,
//                     filters,
//                     sortField: sorter.field,
//                     sortOrder: sorter.order,
//                 },
//             }),
//             () => {
//                 scrollToAntSpinContainer();
//                 this.fetchData();
//             },
//         );
//     };


//     handleUpdateInvoices = (record) => {
//         const { t } = this.props;
//         const { id, invoiceNumber, amount } = record;

//         this.setState({ buttonLoading: id });

//         Modal.confirm({
//             title: t('Confirm Invoice Payment'),
//             icon: null,
//             width: 550,
//             content: (
//                 <div className="py-3">
//                     <Card size="small" className="mb-4" style={{ backgroundColor: 'none', border: 'none', boxShadow: 'none' }}>
//                         <div className="d-flex justify-content-between">
//                             <span>{t('Ref')}:</span>
//                             <strong>{invoiceNumber}</strong>
//                         </div>
//                         <div className="d-flex justify-content-between text-danger mt-2">
//                             <span>{t('Total Due')}:</span>
//                             <strong>THB {Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
//                         </div>
//                     </Card>
//                     <Divider />

//                     {/* 2. ผูก ref เข้ากับ Form */}
//                     <Form
//                         ref={this.formRef}
//                         layout="vertical"
//                         initialValues={{
//                             paidDate: dayjs(),
//                             paidMethod: 'BANK_TRANSFER',
//                             note: ''
//                         }}
//                     >
//                         <Form.Item
//                             name="paidDate"
//                             label={t('paidDate')}
//                             rules={[{ required: true, message: t('Please select date') }]}
//                         >
//                             <DatePicker className="w-100" showTime format="YYYY-MM-DD HH:mm:ss" />
//                         </Form.Item>

//                         <Form.Item
//                             name="paidMethod"
//                             label={t('paidMethod')}
//                             rules={[{ required: true }]}
//                         >
//                             <Select>
//                                 <Select.Option value="BANK_TRANSFER">{t('โอนเงินผ่านบัญชีธนาคาร')}</Select.Option>
//                                 <Select.Option value="CASH">{t('เงินสด')}</Select.Option>
//                                 <Select.Option value="CREDIT_CARD">{t('บัตรเครดิต')}</Select.Option>
//                             </Select>
//                         </Form.Item>

//                         <Form.Item name="note" label={t('note')}>
//                             <Input.TextArea style={{ textTransform: "lowercase" }} rows={3} placeholder={t('Enter note here...')} />
//                         </Form.Item>
//                     </Form>
//                 </div>
//             ),
//             okText: t('Confirm Payment'),
//             cancelText: t('Cancel'),
//             centered: true,
//             okButtonProps: { type: 'primary', loading: this.state.buttonLoading === id },
//             onCancel: () => { this.setState({ buttonLoading: 0 }); },
//             onOk: async () => {
//                 // 3. เรียกใช้ผ่าน this.formRef.current
//                 if (this.formRef.current) {
//                     try {
//                         const values = await this.formRef.current.validateFields();

//                         this.setState({ loading: true });

//                         const payload = {
//                             invoiceId: id,
//                             paidDate: values.paidDate.format('YYYY-MM-DD HH:mm:ss'),
//                             paidMethod: values.paidMethod,
//                             note: values.note
//                         };

//                         const res = await Apiauth.updateInvoiceStatus(payload);

//                         if (res.status === 200 || res.data?.success) {
//                             showToast("success", t("Update successfully"));
//                             this.fetchData();
//                         }
//                     } catch (error) {
//                         // ถ้า Validate ไม่ผ่าน จะติดตรงนี้
//                         if (error.errorFields) {
//                             return Promise.reject();
//                         }
//                         showToast("error", t("Failed to update invoice"));
//                     } finally {
//                         setTimeout(() => {
//                             this.setState({ loading: false, buttonLoading: 0 });
//                         }, 1000)
//                     }
//                 }
//             },
//         });
//     };
//     calculateTotals = (data = []) => {
//         return data.reduce((acc, current) => {
//             return {
//                 totalTransactions: acc.totalTransactions + (current.totalTransactions || 0),
//                 totalFee: acc.totalFee + (current.fee || 0)
//             };
//         }, { totalTransactions: 0, totalFee: 0 }); // ค่าเริ่มต้น
//     };


//     render() {
//         const { t } = this.props;
//         const { loading, startDate, tableParams, isMobile, dataSource } = this.state;
//         const currentLanguage = i18next.language;
//         dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);
//         let currentLng = currentLanguage === "lao" ? "lo" : currentLanguage;
//         const onMenuClick = (e) => {
//             console.log('click', e);
//         };
//         const itemsDropdown = [
//             {
//                 key: '1',
//                 label: 'Copy row data',
//             },

//         ];
//         const columns = [
//             Table.EXPAND_COLUMN,
//             {
//                 title: t('Ref'),
//                 dataIndex: 'invoiceNumber',
//                 key: 'invoiceNumber',
//                 render: (ref) => (
//                     <div className="d-flex align-items-center" style={{ cursor: "copy" }} onClick={() => CopyTextToClipboard(ref)}>
//                         <span
//                             className="text-truncate hover"
//                             title={ref}
//                             style={{
//                                 textWrap: "nowrap",
//                                 maxWidth: "120px",
//                                 display: "inline-block",
//                                 color: "#007bff"
//                             }}
//                         >
//                             {ref}
//                         </span>
//                     </div>
//                 ),
//             },
//             {
//                 title: t('Merchant'),
//                 dataIndex: ['merchant', 'name'], // เข้าถึง object merchant.name
//                 className: "text-truncate",
//                 key: 'merchantName',
//             },
//             {
//                 title: t('invoices monthly'),
//                 className: "text-truncate",
//                 key: 'cycle',
//                 render: (_, record) => (
//                     <span style={{ fontSize: 12 }}>
//                         {dayjs(record.startDate).format("MMM YYYY")}
//                     </span>
//                 )
//             },
//             {
//                 title: t('Status'),
//                 dataIndex: 'status',
//                 key: 'status',
//                 render: (status) => (
//                     <span className={`badge badge-${status === "PAID" ? "success" : "danger"}`} style={{ minWidth: 70 }}>
//                         {t(status)}
//                     </span>
//                 ),
//             },
//             {
//                 title: t('dueDate'),
//                 className: "text-truncate",
//                 key: 'dueDate',
//                 dataIndex: 'dueDate',
//                 render: (_, record) => {

//                     return <span style={{ fontSize: 12, }}>
//                         {moment(record.dueDate).locale(currentLng).format("ll")}
//                     </span>
//                 }
//             },

//             {
//                 title: <b className="d-block text-truncate">{t('paidDate')}</b>,
//                 dataIndex: 'paidDate',
//                 key: 'paidDate',
//                 render: (val, record) => {
//                     return <>
//                         <span style={{ fontSize: 12, }}>
//                             {!val ? "-" : moment(val).locale(currentLng).format("ll")}
//                         </span>
//                     </>
//                 },
//             },
//             {
//                 title: <><b className="d-block text-truncate">{t('fee merchant')}</b> {" "}
//                 </>,
//                 className: "text-truncate",
//                 dataIndex: 'amount',
//                 key: 'amount',
//                 render: (val, record) => {
//                     return <>
//                         <span className={`d-block`} style={{ color: "purple" }}>
//                             THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
//                         </span>

//                     </>
//                 },
//             },
//             {
//                 title: t('fee platform'),
//                 dataIndex: 'amountPlatform',
//                 className: "text-truncate",
//                 key: 'amountPlatform',
//                 render: (val, record) => {
//                     return <span style={{ color: "#3eacff" }}>
//                         THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
//                     </span>
//                 },
//             },
//             {
//                 title: t('Net income'),
//                 className: "text-truncate",
//                 render: (val, record) => {
//                     let netIncome = calculateNetIncome(record.amount, record.amountPlatform);
//                     return <span style={{ fontWeight: '500' }}>
//                         THB {Number(netIncome).toLocaleString(undefined, { minimumFractionDigits: 2 })}
//                     </span>
//                 },
//             },
//             {
//                 title: t('paidMethod'),
//                 className: "text-truncate",
//                 dataIndex: 'paidMethod',
//                 key: 'paidMethod',
//                 render: (val, record) => {
//                     return <>
//                         <span style={{ fontSize: 12, }}>
//                             {!val ? "-" : <code style={{ color: "#888" }}>{t(val)}</code>}
//                         </span>
//                     </>
//                 },
//             },
//             {
//                 title: t('updatedBy'),
//                 dataIndex: 'updatedBy',
//                 key: 'updatedBy',
//                 render: (val, record) => {
//                     return <>
//                         <span style={{ fontSize: 12, }}>
//                             {!val ? "-" : <code style={{ color: "#888" }}>{t(val)}</code>}
//                         </span>
//                     </>
//                 },
//             },
//             {
//                 title: t('note'),
//                 dataIndex: 'note',
//                 key: 'note',
//                 render: (val) => {
//                     return <>
//                         <div className="text-wrap"
//                             style={{ fontSize: 11, width: 150 }} >
//                             {!val ? "-" : <code style={{ color: "#888" }}>{t(val)}</code>}
//                         </div>
//                     </>
//                 },
//             },

//             {
//                 title: <span >{t('Action')}</span>,
//                 key: 'action',
//                 fixed: 'end',
//                 width: 100,
//                 // align: 'center',
//                 render: (_, record) => {
//                     const isPaid = record.status === "PAID";
//                     return (
//                         <div className="d-flex justify-content-center">
//                             {!isPaid ? (
//                                 <Space.Compact>
//                                     <Button
//                                         size="small"
//                                         type="primary"
//                                         loading={this.state.buttonLoading === record.id}
//                                         icon={<CheckOutlined />}
//                                         onClick={() => this.handleUpdateInvoices(record)}
//                                     >
//                                         {this.state.buttonLoading === record.id ? t("Updating...") : t("Confirm Payment")}
//                                     </Button>
//                                     <Dropdown menu={{ itemsDropdown, onClick: (e) => onMenuClick(e) }} placement="bottomRight">
//                                         <Button icon={<EllipsisOutlined />} />
//                                     </Dropdown>
//                                 </Space.Compact>

//                             ) : (
//                                 <span className="text-success">
//                                     <CheckOutlined /> {t("Completed")}
//                                 </span>
//                             )}
//                         </div>
//                     );
//                 },
//             },
//         ];

//         const totalCount = Intl.NumberFormat().format(tableParams.pagination.total);
//         const items = [{
//             label: (
//                 <span style={{ padding: "0 10px" }}>
//                     {t("invoices_list", { count: totalCount })}
//                 </span>
//             ),
//             key: "1",
//             children: (
//                 <div className="table-responsive">
//                     <Table
//                         columns={columns}
//                         rowKey={(record) => record.id}
//                         dataSource={dataSource}
//                         // rowClassName={getRowClassName}
//                         expandable={{
//                             expandedRowRender: (record, index) => {
//                                 const productList = record?.products ? JSON.parse(record.products) : [];
//                                 return (
//                                     <div style={{ margin: 0, backgroundColor: "#f9f9f9", }}>
//                                         <Table className=""
//                                             columns={[
//                                                 { title: t('#'), render: (_, val, index) => t(index + 1) },
//                                                 { title: t('Product'), dataIndex: 'name', key: 'name', render: (val) => t(val) },
//                                                 { title: t('transactions'), dataIndex: 'totalTransactions', key: 'totalTransactions', },
//                                                 {
//                                                     title: t('fee merchant'), dataIndex: 'fee', key: 'fee',
//                                                     render: (val) => (<span style={{ color: "purple" }}>
//                                                         THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
//                                                     </span>)
//                                                 },
//                                                 {
//                                                     title: t('fee platform'), dataIndex: 'feeplatform', key: 'feeplatform',
//                                                     render: (val) => (<span style={{ color: "#3eacff" }}>
//                                                         THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
//                                                     </span>)
//                                                 },

//                                             ]}
//                                             dataSource={productList}
//                                             pagination={false}
//                                             rowKey={(item, index) => `${record.id}-product-${index}`}
//                                         />
//                                     </div>
//                                 );
//                             },
//                             icon: ({ expanded }) => (
//                                 <span style={{ fontSize: 12, color: "#007bff", cursor: "pointer" }}>
//                                     {expanded ? t("Hide Details") : t("View Details")}
//                                 </span>
//                             ),
//                         }}
//                         pagination={{
//                             ...tableParams.pagination,
//                             showSizeChanger: true,
//                             locale: {
//                                 items_per_page: `/ ${t("paged")}`,
//                             },
//                             showTotal: (total, range) => {
//                                 // คำนวณหน้าปัจจุบัน
//                                 const currentPage = tableParams.pagination.current;
//                                 // คำนวณจำนวนหน้าทั้งหมด
//                                 const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

//                                 return (
//                                     <span>
//                                         {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
//                                         <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
//                                         <span style={{ marginLeft: 10 }}>
//                                             {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
//                                         </span>
//                                     </span>
//                                 );
//                             },
//                         }}
//                         loading={loading}
//                         onChange={this.handleTableChange}
//                         scroll={{ x: "max-content" }}
//                         locale={{
//                             emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("No data")} />
//                         }}
//                     />
//                 </div>
//             ),
//         }];

//         return (
//             <div style={{ flex: 1 }} onClick={() => document.body.classList.remove("offcanvas-active")}>
//                 <div className="container-fluid">
//                     <PageHeader
//                         HeaderText={t("manage invoices")}
//                         Breadcrumb={[
//                             {
//                                 name: removeSlashesFromPath(window.location.pathname),
//                                 navigate: window.location.pathname,
//                             },
//                         ]}
//                     />

//                     <div className="row clearfix">
//                         <div className="col-lg-12">

//                             <Card
//                                 title={
//                                     <span style={{ fontSize: 13, fontWeight: "bold" }}>
//                                         <FileDoneOutlined /> {t("invoices_history")}
//                                     </span>
//                                 }
//                                 styles={{ header: { borderBottom: "none" } }}
//                                 extra={
//                                     <RangePickerApp
//                                         onChangeDate={this.onChangeDate}
//                                         isMobile={isMobile}
//                                         startDate={startDate}
//                                         t={t}
//                                     />
//                                 }
//                             >
//                                 <Tabs
//                                     id="invoices-tabs"
//                                     defaultActiveKey="1"
//                                     items={items}
//                                     style={{ padding: "0 10px" }}
//                                 />
//                             </Card>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }

// const mapStateToProps = ({ ioTReducer }) => ({
//     isSecuritySystem: ioTReducer.isSecuritySystem,
// });

// export default connect(mapStateToProps, {})(withTranslation()(ManageInvoices));

import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AppContext from "../../components/AppContext";
import PageHeader from "../../components/PageHeader";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { Card, Empty, Table, Tabs, Button, Modal, Form, Select, Input, DatePicker, Divider, Space, Dropdown } from "antd";
import RangePickerApp from "../../components/rangePickerApp";
import dayjs from "dayjs";
import { getBillingDateRange } from "../../helpers/getBillingDateRange";
import Apiauth from "../../api/Apiauth";
import { calculateNetIncome, scrollToAntSpinContainer, showToast } from "../../utils";
import { FileDoneOutlined, CheckOutlined, EllipsisOutlined } from "@ant-design/icons";
import i18next from "i18next";
import { CopyTextToClipboard } from "../../helpers/copy";
import moment from "moment";
import { CONFIGMERCHENTID } from "../../Data/configMerchant";

const dataDate = getBillingDateRange();

class ManageInvoices extends React.Component {
    static contextType = AppContext;
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            startDate: dayjs(dataDate?.objectDate?.startDate).subtract(1, "month").startOf("month"),
            isMobile: window.innerWidth <= 768,
            dataSource: [],
            buttonLoading: 0,
            tableParams: {
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                filters: {},
                sortField: null,
                sortOrder: null,
            },
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.fetchData();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= 768 });
    };

    fetchData = async (date) => {
        const { startDate, tableParams } = this.state;
        const targetDate = date || startDate;

        this.setState({ loading: true });

        const payload = {
            startDate: dayjs(targetDate).format("YYYY-MM-DD"),
            limit: tableParams.pagination.pageSize,
            page: tableParams.pagination.current,
            sortField: tableParams.sortField,
            sortOrder: tableParams.sortOrder,
        };

        try {
            const res = await Apiauth.getInvoiceList(payload);
            if (res.status === 200) {
                const prodArray = Array.isArray(res.data?.data) ? res.data.data : [];
                this.setState({
                    dataSource: prodArray,
                    tableParams: {
                        ...tableParams,
                        pagination: {
                            ...tableParams.pagination,
                            total: res.data.count,
                        }
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            showToast("error", "Failed to fetch data.");
        } finally {
            setTimeout(() => {
                this.setState({ loading: false });
            }, 500);
        }
    };

    onChangeDate = (item) => {
        const newStartDate = dayjs(item?.startDate);
        this.setState(prevState => ({
            startDate: newStartDate,
            tableParams: {
                ...prevState.tableParams,
                pagination: { ...prevState.tableParams.pagination, current: 1 }
            }
        }), () => {
            this.fetchData(newStartDate);
        });
    };

    handleTableChange = (pagination, filters, sorter) => {
        this.setState(
            (prevState) => ({
                tableParams: {
                    ...prevState.tableParams,
                    pagination,
                    filters,
                    sortField: sorter.field,
                    sortOrder: sorter.order,
                },
            }),
            () => {
                scrollToAntSpinContainer();
                this.fetchData();
            },
        );
    };

    // ฟังก์ชันสำหรับจัดการ Action Dropdown (Copy Row Data)
    handleMenuClick = (e, record) => {
        const { t } = this.props;
        if (e.key === '1') {
            try {

                // คัดลอกข้อมูลเฉพาะที่จำเป็น หรือคัดลอกทั้งก้อน Object ในรูปแบบ String
                const rowDataString = JSON.stringify(record, null, 2);
                let rowsData = `${record?.merchant?.name} => ${dayjs(rowDataString?.startDate).format("MMM YYYY")} = THB ${Intl.NumberFormat().format(record.amount)}\n`;

                CopyTextToClipboard(rowsData);
            } catch (err) {
                showToast("error", t("Failed to copy data"));
            }
        }
    };

    handleUpdateInvoices = (record) => {
        const { t } = this.props;
        const { id, invoiceNumber, amount } = record;

        this.setState({ buttonLoading: id });

        Modal.confirm({
            title: t('Confirm Invoice Payment'),
            icon: null,
            width: 550,
            content: (
                <div className="py-3">
                    <Card size="small" className="mb-4" style={{ backgroundColor: 'none', border: 'none', boxShadow: 'none' }}>
                        <div className="d-flex justify-content-between">
                            <span>{t('Ref')}:</span>
                            <strong>{invoiceNumber}</strong>
                        </div>
                        <div className="d-flex justify-content-between text-danger mt-2">
                            <span>{t('Total Due')}:</span>
                            <strong>THB {Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
                        </div>
                    </Card>
                    <Divider />

                    <Form
                        ref={this.formRef}
                        layout="vertical"
                        initialValues={{
                            paidDate: dayjs(),
                            paidMethod: 'BANK_TRANSFER',
                            note: ''
                        }}
                    >
                        <Form.Item
                            name="paidDate"
                            label={t('paidDate')}
                            rules={[{ required: true, message: t('Please select date') }]}
                        >
                            <DatePicker className="w-100" showTime format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>

                        <Form.Item
                            name="paidMethod"
                            label={t('paidMethod')}
                            rules={[{ required: true }]}
                        >
                            <Select>
                                <Select.Option value="BANK_TRANSFER">{t('โอนเงินผ่านบัญชีธนาคาร')}</Select.Option>
                                <Select.Option value="CASH">{t('เงินสด')}</Select.Option>
                                <Select.Option value="CREDIT_CARD">{t('บัตรเครดิต')}</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item name="note" label={t('note')}>
                            <Input.TextArea style={{ textTransform: "lowercase" }} rows={3} placeholder={t('Enter note here...')} />
                        </Form.Item>
                    </Form>
                </div>
            ),
            okText: t('Confirm Payment'),
            cancelText: t('Cancel'),
            centered: true,
            // แก้ไขปัญหา UI Loading ไม่ทำงานสัมพันธ์กับ State ใน Modal.confirm
            okButtonProps: { type: 'primary' },
            onCancel: () => { this.setState({ buttonLoading: 0 }); },
            onOk: async () => {
                if (this.formRef.current) {
                    try {
                        const values = await this.formRef.current.validateFields();
                        this.setState({ loading: true });

                        const payload = {
                            invoiceId: id,
                            paidDate: values.paidDate.format('YYYY-MM-DD HH:mm:ss'),
                            paidMethod: values.paidMethod,
                            note: values.note
                        };

                        const res = await Apiauth.updateInvoiceStatus(payload);

                        if (res.status === 200 || res.data?.success) {
                            showToast("success", t("Update successfully"));
                            this.fetchData();
                        }
                    } catch (error) {
                        if (error.errorFields) {
                            return Promise.reject();
                        }
                        showToast("error", t("Failed to update invoice"));
                    } finally {
                        setTimeout(() => {
                            this.setState({ loading: false, buttonLoading: 0 });
                        }, 1000)
                    }
                }
            },
        });
    };

    calculateTotals = (data = []) => {
        return data.reduce((acc, current) => {
            return {
                totalTransactions: acc.totalTransactions + (current.totalTransactions || 0),
                totalFee: acc.totalFee + (current.fee || 0)
            };
        }, { totalTransactions: 0, totalFee: 0 });
    };

    render() {
        const { t } = this.props;
        const { loading, startDate, tableParams, isMobile, dataSource } = this.state;
        const currentLanguage = i18next.language;
        dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);
        let currentLng = currentLanguage === "lao" ? "lo" : currentLanguage;

        // รายการไอเทมใน Dropdown
        const itemsDropdown = [
            {
                key: '1',
                label: t('Copy row data'),
                icon: <i className="fa fa-copy" style={{ marginRight: 5 }}></i>
            },
        ];

        let EmptyBTN = CONFIGMERCHENTID || [];

        const columns = [
            Table.EXPAND_COLUMN,
            {
                title: t('Ref'),
                dataIndex: 'invoiceNumber',
                key: 'invoiceNumber',
                render: (ref) => (
                    <div className="d-flex align-items-center" style={{ cursor: "copy" }} onClick={() => {
                        CopyTextToClipboard(ref);
                        showToast("success", t("Copied Reference"));
                    }}>
                        <span
                            className="text-truncate hover"
                            title={ref}
                            style={{
                                textWrap: "nowrap",
                                maxWidth: "120px",
                                display: "inline-block",
                                color: "#007bff"
                            }}
                        >
                            {ref}
                        </span>
                    </div>
                ),
            },
            {
                title: t('Merchant'),
                dataIndex: ['merchant', 'name'],
                className: "text-truncate",
                key: 'merchantName',
            },
            {
                title: t('invoices monthly'),
                className: "text-truncate",
                key: 'cycle',
                render: (_, record) => (
                    <span style={{ fontSize: 12 }}>
                        {dayjs(record.startDate).format("MMM YYYY")}
                    </span>
                )
            },
            {
                title: t('Status'),
                dataIndex: 'status',
                key: 'status',
                render: (status) => (
                    <span className={`badge badge-${status === "PAID" ? "success" : "danger"}`} style={{ minWidth: 70 }}>
                        {t(status)}
                    </span>
                ),
            },
            {
                title: t('dueDate'),
                className: "text-truncate",
                key: 'dueDate',
                dataIndex: 'dueDate',
                render: (_, record) => {
                    return <span style={{ fontSize: 12 }}>
                        {moment(record.dueDate).locale(currentLng).format("ll")}
                    </span>
                }
            },
            {
                title: <b className="d-block text-truncate">{t('paidDate')}</b>,
                dataIndex: 'paidDate',
                key: 'paidDate',
                render: (val) => {
                    return <span style={{ fontSize: 12 }}>
                        {!val ? "-" : moment(val).locale(currentLng).format("ll")}
                    </span>
                },
            },
            {
                title: <b className="d-block text-truncate">{t('fee merchant')}</b>,
                className: "text-truncate",
                dataIndex: 'amount',
                key: 'amount',
                render: (val) => {
                    return <span className="d-block" style={{ color: "purple" }}>
                        THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                },
            },
            {
                title: t('fee platform'),
                dataIndex: 'amountPlatform',
                className: "text-truncate",
                key: 'amountPlatform',
                render: (val) => {
                    return <span style={{ color: "#3eacff" }}>
                        THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                },
            },
            {
                title: t('Net income'),
                className: "text-truncate",
                render: (_, record) => {
                    let netIncome = calculateNetIncome(record.amount, record.amountPlatform);
                    return <span style={{ fontWeight: '500' }}>
                        THB {Number(netIncome).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                },
            },
            {
                title: t('paidMethod'),
                className: "text-truncate",
                dataIndex: 'paidMethod',
                key: 'paidMethod',
                render: (val) => {
                    return <span style={{ fontSize: 12 }}>
                        {!val ? "-" : <code style={{ color: "#888" }}>{t(val)}</code>}
                    </span>
                },
            },
            {
                title: t('updatedBy'),
                dataIndex: 'updatedBy',
                key: 'updatedBy',
                render: (val) => {
                    return <span style={{ fontSize: 12 }}>
                        {!val ? "-" : <code style={{ color: "#888" }}>{t(val)}</code>}
                    </span>
                },
            },
            {
                title: t('note'),
                dataIndex: 'note',
                key: 'note',
                render: (val) => {
                    return <div className="text-wrap" style={{ fontSize: 11, width: 150 }}>
                        {!val ? "-" : <code style={{ color: "#888" }}>{t(val)}</code>}
                    </div>
                },
            },
            {
                title: <span>{t('Action')}</span>,
                key: 'action',
                fixed: 'end',
                width: 100,
                render: (_, record) => {
                    const isPaid = record.status === "PAID";
                    return (
                        <div className="d-flex justify-content-center">
                            {!isPaid ? (
                                <Space.Compact>
                                    <Button

                                        loading={this.state.buttonLoading === record.id}
                                        icon={<CheckOutlined />}
                                        onClick={() => this.handleUpdateInvoices(record)}
                                    >
                                        {this.state.buttonLoading === record.id ? t("Updating...") : t("Confirm Payment")}
                                    </Button>
                                    {EmptyBTN.includes(record?.merchantId) ? null : <Dropdown
                                        arrow
                                        menu={{
                                            items: itemsDropdown,
                                            onClick: (e) => this.handleMenuClick(e, record)
                                        }}
                                        placement="bottomRight"
                                    >
                                        <Button icon={<EllipsisOutlined />} />
                                    </Dropdown>}

                                </Space.Compact>
                            ) : (
                                <span className="text-success">
                                    <CheckOutlined /> {t("Completed")}
                                </span>
                            )}
                        </div>
                    );
                },
            },
        ];

        const totalCount = Intl.NumberFormat().format(tableParams.pagination.total);
        const items = [{
            label: (
                <span style={{ padding: "0 10px" }}>
                    {t("invoices_list", { count: totalCount })}
                </span>
            ),
            key: "1",
            children: (
                <div className="table-responsive">
                    <Table
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={dataSource}
                        expandable={{
                            expandedRowRender: (record) => {
                                const productList = record?.products ? JSON.parse(record.products) : [];
                                return (
                                    <div style={{ margin: 0, backgroundColor: "#f9f9f9" }}>
                                        <Table
                                            columns={[
                                                { title: t('#'), render: (_, __, index) => t(index + 1) },
                                                { title: t('Product'), dataIndex: 'name', key: 'name', render: (val) => t(val) },
                                                { title: t('transactions'), dataIndex: 'totalTransactions', key: 'totalTransactions' },
                                                {
                                                    title: t('fee merchant'), dataIndex: 'fee', key: 'fee',
                                                    render: (val) => (<span style={{ color: "purple" }}>
                                                        THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                    </span>)
                                                },
                                                {
                                                    title: t('fee platform'), dataIndex: 'feeplatform', key: 'feeplatform',
                                                    render: (val) => (<span style={{ color: "#3eacff" }}>
                                                        THB {Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                    </span>)
                                                },
                                            ]}
                                            dataSource={productList}
                                            pagination={false}
                                            rowKey={(_, index) => `${record.id}-product-${index}`}
                                        />
                                    </div>
                                );
                            },
                            icon: ({ expanded, onExpand, record }) => (
                                <span
                                    style={{ fontSize: 12, color: "#007bff", cursor: "pointer" }}
                                    onClick={e => onExpand(record, e)}
                                >
                                    {expanded ? t("Hide Details") : t("View Details")}
                                </span>
                            ),
                        }}
                        pagination={{
                            ...tableParams.pagination,
                            showSizeChanger: true,
                            locale: {
                                items_per_page: `/ ${t("paged")}`,
                            },
                            showTotal: (total, range) => {
                                const currentPage = tableParams.pagination.current;
                                const totalPages = Math.ceil(total / tableParams.pagination.pageSize);
                                return (
                                    <span>
                                        <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                                        <span style={{ marginLeft: 10 }}>
                                            {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                                        </span>
                                    </span>
                                );
                            },
                        }}
                        loading={loading}
                        onChange={this.handleTableChange}
                        scroll={{ x: "max-content" }}
                        locale={{
                            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("No data")} />
                        }}
                    />
                </div>
            ),
        }];

        return (
            <div style={{ flex: 1 }} onClick={() => document.body.classList.remove("offcanvas-active")}>
                <div className="container-fluid">
                    <PageHeader
                        HeaderText={t("manage invoices")}
                        Breadcrumb={[
                            {
                                name: removeSlashesFromPath(window.location.pathname),
                                navigate: window.location.pathname,
                            },
                        ]}
                    />
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <Card
                                title={
                                    <span style={{ fontSize: 13, fontWeight: "bold" }}>
                                        <FileDoneOutlined /> {t("invoices_history")}
                                    </span>
                                }
                                styles={{ header: { borderBottom: "none" } }}
                                extra={
                                    <RangePickerApp
                                        onChangeDate={this.onChangeDate}
                                        isMobile={isMobile}
                                        startDate={startDate}
                                        t={t}
                                    />
                                }
                            >
                                <Tabs
                                    id="invoices-tabs"
                                    defaultActiveKey="1"
                                    items={items}
                                    style={{ padding: "0 10px" }}
                                />
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default connect(mapStateToProps, {})(withTranslation()(ManageInvoices));